const middleware = {}

middleware['authenticated'] = require('../middleware/authenticated.js')
middleware['authenticated'] = middleware['authenticated'].default || middleware['authenticated']

middleware['check-auth'] = require('../middleware/check-auth.js')
middleware['check-auth'] = middleware['check-auth'].default || middleware['check-auth']

middleware['check-before-move'] = require('../middleware/check-before-move.js')
middleware['check-before-move'] = middleware['check-before-move'].default || middleware['check-before-move']

middleware['handle-login-route'] = require('../middleware/handle-login-route.js')
middleware['handle-login-route'] = middleware['handle-login-route'].default || middleware['handle-login-route']

middleware['load-private-quote'] = require('../middleware/load-private-quote.js')
middleware['load-private-quote'] = middleware['load-private-quote'].default || middleware['load-private-quote']

middleware['load-public-quote'] = require('../middleware/load-public-quote.js')
middleware['load-public-quote'] = middleware['load-public-quote'].default || middleware['load-public-quote']

export default middleware
